module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"default":"How Can I Help You Today?"},"es":{"default":"¿Cómo puedo ayudarlo?"}}')
  delete Component.options._Ctor
}
